import {
    SET_MOBILE_NAVIGATION,
} from 'framework/vuex/mutation-types';

import * as getters from './getters';
import * as actions from './actions';


/**
 * The mutations available in the module
 */
const mutations = {
    [SET_MOBILE_NAVIGATION](state, { isOpen }) {
        state.navigation.mobile.isOpen = isOpen;
    },
};

/**
 * The state of the module
 */
const state = {
    navigation: {
        mobile: {
            isOpen: false,
        },
    },
};


export default {
    actions,
    state,
    getters,
    mutations,
};



// WEBPACK FOOTER //
// ./vehi-industriepfad/assets/src/js/app/framework/vuex/modules/navigation/index.js